import { type QueryResolvers } from '../../../../generated/graphql'
import type { ApolloResolverContext } from '@edge/spark/io-apollo'
import { getTempLayouts } from '../../../../Stores'

export const layoutsResolver: QueryResolvers<ApolloResolverContext>['layouts'] = async () => {
    console.debug('io-dashboards layoutsResolver deprecated, use getLayouts')

    if (Math.random()) {
        throw new Error('getLayouts Not Implemented')
    }

    const layouts = getTempLayouts()
    return layouts
}
